import React from "react";
import { Box } from "@mui/material";
import FormBuilder from "../../../Common/FormBuilder/FormBuilder";
import ScopeOfWorkTable from "./ScopeOfWorkTable";

function ScopeOfWorkContent({ segment, appraisalId, onFormFieldChange, appCode }) {
    const canUpdate = segment?.canUpdate ?? false;

    return (
        <Box component="div">
            <ScopeOfWorkTable
                canUpdate={canUpdate}
                items={segment?.items ?? []}
                appraisalId={appraisalId}
                appCode={appCode}
            />
            <FormBuilder
                form={segment?.form ?? []}
                canUpdate={canUpdate}
                onFieldChange={onFormFieldChange}
            />
        </Box>
    );
}
export default ScopeOfWorkContent;
